import axios from 'axios'
import { backendPrefix } from '../backendPrefix'

export async function getFaucet(address:string, targetChainId: string, token:string) {
  return axios
  .post(backendPrefix + `/api/v1/faucet`, {
    address: address,
    targetChainId: targetChainId,
    token: token
  })
  .then(response => {
    return {
      op: 'success',
      data: response.data
    }
  })
  .catch(error => {
    console.log('Faucet error:', error)
    return {
      op: 'fail',
      data: error
    }
  })
}